import React from 'react';
import { Chip } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { IPD_COLORS } from '../../theme';
import { invChipSx } from '../StatusChip';

export default function ActiveStatusBadge({ active }) {
  const isActive = active !== false;
  const color = isActive ? IPD_COLORS.success.text : IPD_COLORS.error.text;
  return (
    <Chip
      icon={
        <FiberManualRecordIcon
          sx={{ fontSize: '10px !important', color: `${color} !important` }}
        />
      }
      label={isActive ? 'Active' : 'Inactive'}
      size="small"
      sx={{
        ...invChipSx({ color, variant: 'soft' }),
        '& .MuiChip-icon': { ml: 0.75 },
      }}
    />
  );
}
